import React, { createContext, useContext, useMemo } from "react";
import { useConfigContext } from "./ConfigContext";
import { useCssVariables } from "../hooks/useCssVariables";
import { Club } from "../models/club";
type ClubContextValue = {
	club: Club | null;
	personalAreaUrl: string;
};

const ClubContext = createContext<ClubContextValue | undefined>(undefined);

export const ClubProvider: React.FC<{
	club: Club;
	children: React.ReactNode;
}> = ({ club, children }) => {
	const { config } = useConfigContext();
	useCssVariables(club, config);

	const personalAreaUrl = useMemo((): string => {
		return club?.personalAreaSiteUrl || "";
	}, [club]);

	return (
		<ClubContext.Provider value={{ club, personalAreaUrl }}>
			{children}
		</ClubContext.Provider>
	);
};

export function useClubContext() {
	const context = useContext(ClubContext);
	if (!context) {
		throw new Error("useClubContext must be used within a ClubProvider");
	}
	return context;
}
